// extracted by mini-css-extract-plugin
export default {"main":"styles_main__xuKjh","img_side":"styles_img_side__h1Wvf","form_side":"styles_form_side__qoGe5"};